import React from "react";
import { FlowpiDialog } from "./ui/flowpi-dialog";

function looksLikeFooter(element) {
  if (!React.isValidElement(element)) return false;
  const className = String(element.props.className || "");
  return className.includes("justify-end") || className.includes("border-t");
}

function splitLegacyContent(children) {
  const direct = React.Children.toArray(children);
  if (direct.length > 1 && looksLikeFooter(direct.at(-1))) {
    return { body: direct.slice(0, -1), footer: direct.at(-1) };
  }
  if (direct.length === 1 && React.isValidElement(direct[0])) {
    const wrapper = direct[0];
    // Keep submit controls inside their owning form. Established form modals
    // retain their composition while the shared shell supplies modal behavior.
    if (wrapper.type === "form") return { body: children, footer: null };
    const nested = React.Children.toArray(wrapper.props.children);
    if (nested.length > 1 && looksLikeFooter(nested.at(-1))) {
      return {
        body: React.cloneElement(wrapper, {}, nested.slice(0, -1)),
        footer: nested.at(-1),
      };
    }
  }
  return { body: children, footer: null };
}

/**
 * Reusable modal with a soft elevated surface.
 */
export default function Modal({ title, children, onClose, testid = "modal", size = "md", busy = false }) {
  const semanticSize = size === "lg" ? "workflow" : size === "sm" ? "confirmation" : "form";
  const { body, footer } = splitLegacyContent(children);
  return (
    <FlowpiDialog
      open
      onClose={onClose}
      busy={busy}
      size={semanticSize}
      title={title}
      closeLabel={`Close ${title}`}
      closeTestId={`${testid}-close`}
      testId={testid}
      footer={footer}
    >
      {body}
    </FlowpiDialog>
  );
}
